<template>

	<div class="medicine">

		<page-bar />

		<h3 class="page-title" v-translate>Medicações</h3>

		<div class="portlet light">

			<div class="portlet-title">

				<div class="row">

					<medicine-filters />

				</div>

				<medicine-labels />

			</div>

			<div class="portlet-body">

				<medicine-pending />

				<medicine-history />

			</div>

		</div>

	</div>

</template>

<script>

	import Medicine from './';
	export default Medicine;

</script>



// WEBPACK FOOTER //
// medicine.vue?1156a5fa